// MondoBarf — card variant switcher
(function () {
  var fmt = window.Shopify && window.Shopify.formatMoney
    ? function (cents) { return Shopify.formatMoney(cents, window.currency.moneyFormat); }
    : function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; };

  function initCard(card) {
    var container = card.querySelector('[data-product-handle]');
    if (!container) return;

    var pills      = container.querySelectorAll('.mb-card-variant-pill');
    var masterSel  = card.querySelector('[data-master-select]');
    var priceEl    = card.querySelector('.c-product-card__price');
    var compareEl  = card.querySelector('.c-product-card__compare-at-price');
    var submitBtn  = card.querySelector('[type="submit"]');
    var hiddenQty  = card.querySelector('[data-stock]');

    function selectVariant(pill) {
      var variantId   = pill.dataset.variantId;
      var price       = parseInt(pill.dataset.variantPrice, 10);
      var compare     = parseInt(pill.dataset.variantCompare, 10) || 0;
      var available   = pill.dataset.variantAvailable === 'true';

      // aggiorna pill attiva
      pills.forEach(function (p) { p.classList.remove('mb-card-variant-pill--active'); });
      pill.classList.add('mb-card-variant-pill--active');

      // aggiorna master select (per il form add-to-cart)
      if (masterSel) {
        Array.from(masterSel.options).forEach(function (opt) {
          opt.selected = opt.value === variantId;
        });
      }

      // aggiorna prezzo
      if (priceEl) priceEl.textContent = fmt(price);
      if (compareEl) {
        if (compare > price) {
          compareEl.textContent = fmt(compare);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      // aggiorna bottone
      if (submitBtn) {
        submitBtn.disabled = !available;
        if (!available) {
          submitBtn.classList.add('c-button--disabled');
          submitBtn.textContent = 'ESAURITO';
        } else {
          submitBtn.classList.remove('c-button--disabled');
          submitBtn.textContent = submitBtn.dataset.labelAdd || 'AGGIUNGI AL CARRELLO';
        }
      }

      // aggiorna stock hidden input
      if (hiddenQty) hiddenQty.value = available ? 1 : 0;
    }

    pills.forEach(function (pill) {
      if (submitBtn && !submitBtn.dataset.labelAdd) {
        submitBtn.dataset.labelAdd = submitBtn.textContent.trim();
      }
      if (!pill.disabled) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          selectVariant(pill);
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.js-product-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
